import type { ReactNode } from 'react'

export interface CardProps {
  title?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}

export function Card({ title, action, children, className = '' }: CardProps) {
  return (
    <section className={`rounded-sm border border-ostrel-line bg-ostrel-card ${className}`}>
      {(title || action) && (
        <header className="flex flex-wrap items-center justify-between gap-2 border-b border-ostrel-line px-4 py-3">
          {title && (
            <h2 className="text-[10px] font-semibold uppercase tracking-widest text-ostrel-ink-muted">
              {title}
            </h2>
          )}
          {action}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  )
}
